import { render } from "./TheProfessionalExpedientFileTreatmentsList.vue?vue&type=template&id=4acd0af0&scoped=true&ts=true"
import script from "./TheProfessionalExpedientFileTreatmentsList.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalExpedientFileTreatmentsList.vue?vue&type=script&lang=ts"

import "./TheProfessionalExpedientFileTreatmentsList.vue?vue&type=style&index=0&id=4acd0af0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acd0af0"]])

export default __exports__